export const faqs = [
  {
    q: "91免费影视平台是做什么的？",
    a: "91免费影视平台是一个影视内容的聚合与浏览平台，帮助用户通过分类、筛选与搜索，快速找到感兴趣的电影、电视剧、综艺与动漫作品，并查看详细的作品信息。",
  },
  {
    q: "平台上的影视内容可以真实播放吗？",
    a: "不能。本站为演示站点，播放、下载等接口均为前端界面示意，不提供任何真实影视资源。点击播放后仅展示演示画面与提示，如需观看请前往正规授权平台。",
  },
  {
    q: "网站上的影视名称、演员和评分是真实的吗？",
    a: "全部为虚构演示内容。站内的影视作品、人物、评分及简介均用于展示页面排版与交互效果，不代表任何真实作品或人物信息。",
  },
  {
    q: "如何快速找到想看的影视？",
    a: "你可以使用顶部或搜索页的搜索框输入关键词，也可以在分类列表页通过地区、年份、评分区间进行复合筛选，再配合按热门、最新、评分排序，快速定位目标作品。",
  },
  {
    q: "收藏功能需要注册或登录吗？",
    a: "不需要。收藏功能完全在浏览器本地完成，数据保存在你自己的设备上，点击卡片或详情页的爱心按钮即可收藏或取消，刷新页面后依然保留。",
  },
  {
    q: "为什么有些筛选条件下没有结果？",
    a: "当地区、年份与评分区间的组合过于严格时，可能暂时没有匹配的作品。你可以点击“重置筛选条件”清空全部条件，或放宽部分条件后重新筛选。",
  },
  {
    q: "手机上可以正常使用吗？",
    a: "可以。页面已针对手机端进行适配，导航会折叠为菜单，筛选栏以抽屉形式弹出，影视卡片会自动调整为适合屏幕的单列或双列布局，浏览与操作都很顺手。",
  },
  {
    q: "如何向平台提出建议或反馈问题？",
    a: "你可以前往“关于我们”页面，在在线反馈表单中填写你的建议或问题并提交，我们会认真查看每一条留言，持续优化平台体验。",
  },
];